export class ToolOutputFormatter {
	format(
		toolName: string,
		_args: Record<string, unknown> | null | undefined,
		output: string,
		options: { isError?: boolean } = {}
	): string {
		const name = (toolName ?? "").trim();
		if (!name) {
			return "";
		}
		const payload = (output as any)?.toString?.()?.trim?.() ?? "";
		const isError = Boolean(options.isError);

		if (!payload && !isError) {
			return "";
		}

		return `<tool_response>\n${payload}\n</tool_response>`;
	}
}

const sharedFormatter = new ToolOutputFormatter();

export function formatAgentToolOutput(
	toolName: string,
	args: Record<string, unknown> | null | undefined,
	output: string,
	options: { isError?: boolean } = {}
): string {
	return sharedFormatter.format(toolName, args, output, options);
}
